var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-box bgff" },
    [
      _c("banner-swiper"),
      _c(
        "div",
        { staticClass: "def-w" },
        [
          _c("data-stats"),
          _c(
            "div",
            { staticClass: "f-b-c mb-30 mt-30" },
            [_c("tab-news"), _c("login-entry")],
            1
          ),
          _c("advert-comp", { attrs: { "adv-type": "AD_A" } }),
          _c("purchase-block", {
            attrs: { "project-type": "GC", "des-txt": "" },
          }),
          _c("purchase-block", {
            attrs: { "project-type": "FW", "des-txt": "" },
          }),
          _c("advert-comp", {
            staticClass: "mt-30",
            attrs: { "adv-type": "AD_B" },
          }),
          _c("purchase-block", {
            attrs: { "project-type": "HW", "des-txt": "" },
          }),
          _c("purchase-block", {
            attrs: { "project-type": "QT", "des-txt": "" },
          }),
          _c("friendly-link"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }